import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  submitCorporateAndOrgStructureFailure,
  submitCorporateAndOrgStructureRequest,
} from "../../../../store/features/actions/corporateAndOrgStructureActions";
import {
  getAllSubdimensionMatches,
  getAllPageInsights,
} from "../../../../services/commonService";
import "./OperationsSupplyChain.css";
import LogisticsDeliveryPerformance from "./LogisticsDeliveryPerformance";
import OperationalEfficiencyMetrics from "./OperationalEfficiencyMetrics";
import TopRightActionLinks from "../TopRightActionLinks";
import InsightBlock from "../InsightBlock";
import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
import AIChat from "../../Chat/AiChat";
import { useParams } from "react-router-dom";
import GenericTableSkeleton from "../../skeletons/tableSkeleton/genericTableSkeleton";

function OperationsSupplyChain() {
  const { clientName, competitorName } = useParams();
  const [showConversationModal, setShowConversationModal] = useState(false);
  const [pagePositives, setPagePositives] = useState([]);
  const [pageNegatives, setPageNegatives] = useState([]);
  const [pageSoWhat, setPageSoWhat] = useState([]);
  const dispatch = useDispatch();

  const [logisticsAndDeliveryPerformance, setLogisticsAndDeliveryPerformance] =
    useState([]);
  const [operationalEfficiencyMetrics, setOperationalEfficiencyMetrics] =
    useState([]);

  const { loading, data, error } = useSelector(
    (state) => state.corporateAndOrgStructureReducer
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    dispatch(
      submitCorporateAndOrgStructureRequest(
        "Operations & Supply Chain Benchmarking",
        clientName
      )
    );
  }, []);

  useEffect(() => {
    const tempLogisticsAndDeliveryPerformance = getAllSubdimensionMatches(
      data,
      "Logistics & Delivery Performance"
    );
    setLogisticsAndDeliveryPerformance(tempLogisticsAndDeliveryPerformance);

    const tempOperationalEfficiencyMetrics = getAllSubdimensionMatches(
      data,
      "Operational Efficiency Metrics"
    );
    setOperationalEfficiencyMetrics(tempOperationalEfficiencyMetrics);

    const { positive, negative, sowhat } = getAllPageInsights(data);
    setPagePositives(positive || []);
    setPageNegatives(negative || []);
    setPageSoWhat(sowhat || []);
  }, [data]);
  const successMessage = [];
  const handleAiConversation = () => console.log("AI conversation clicked");
  const handleDownload = () => console.log("Download clicked");

  const actions = [
    {
      type: "conversation",
      title: "Conversation",
      onClick: () => {
        setShowConversationModal((prev) => !prev);
      },
    },
    { type: "download", title: "Download", onClick: handleDownload },
  ];

  return (
    <div>
      <div className="operations_supply_chain_wrapper">
        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <InsightBlock
            title={"Operations & Supply Chain Benchmarking"}
            overview={
              "Benchmarking distribution lead times, warehouse infrastructure, and supply chain risk mitigation efforts across Henkel, Bostik, and Taylor Adhesive."
            }
            actions={actions}
            pagePositives={pagePositives}
            pageNegatives={pageNegatives}
            pageSoWhat={pageSoWhat}
          />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <LogisticsDeliveryPerformance
            logisticsAndDeliveryPerformance={logisticsAndDeliveryPerformance}
          />
        )}

        {loading ? (
          <GenericTableSkeleton colCount={3} rowCount={5} />
        ) : (
          <OperationalEfficiencyMetrics
            operationalEfficiencyMetrics={operationalEfficiencyMetrics}
          />
        )}
      </div>

      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img
                    src="/img/ai_insight_top.png"
                    alt="icon"
                    className="ai_icon"
                  />
                </div>
                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This:{" "}
                    {competitorName ?? "Tailored Chemical Products"} - Market
                    Insights
                  </h5>
                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>
              <div className="ai_insight_right"></div>
            </div>
          }
          comp={<AIChat section={"Operations & Supply Chain Benchmarking"} />}
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </div>
  );
}

export default OperationsSupplyChain;
